<template>

  <div class="user">


    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
       

        <el-form-item label="">
          <el-input v-model="formInline.buser_search" placeholder="请输入名称/昵称"></el-input>
        </el-form-item>
     

        <el-form-item label="类型">
          <el-select size="small" v-model="formInline.code" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="门店" value="store"></el-option>
            <el-option label="业务员" value="salesperson"></el-option>
            <el-option label="用户" value="user"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否同步">
          <el-select size="small" v-model="formInline.is_sync_product" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="未同步" :value="0"></el-option>
            <el-option label="已同步" :value="1"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click="sync('barcode')">同步出货记录</el-button>
          <!-- <el-button type="primary" @click="sync('salesperson')">同步业务员</el-button>
          <el-button type="primary" @click="sync('user')">同步用户</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="id" label="ID" > </el-table-column>
            <el-table-column prop="bar_code" label="条形码" > </el-table-column>
            <el-table-column prop="product_bar_code" label="产品条形码" > </el-table-column>

            <el-table-column prop="type" label="类型" > 
              <template slot-scope="scope">
                <span v-if="scope.row.type==1">仓库到业务员</span>
                <span v-if="scope.row.type==2">业务员到门店</span>
                <span v-if="scope.row.type==3">生产到仓库</span>
                <span v-if="scope.row.type==4">仓库到货调</span>
                <span v-if="scope.row.type==5">货调到业务员</span>
                <span v-if="scope.row.type==6">仓库调货给仓库</span>
            </template>
            </el-table-column>

            <el-table-column prop="goods_name" label="产品名称" > </el-table-column>
            <el-table-column prop="goods_spec" label="产品规格" > </el-table-column>
            <el-table-column prop="count" label="数量" > </el-table-column>
            <el-table-column prop="price" label="价格" > </el-table-column>
            <el-table-column prop="product_price" label="产品价格" > </el-table-column>

            <el-table-column prop="is_sync_product" label="是否同步产品" >
              <template slot-scope="scope">
                <span v-if="scope.row.is_sync_product==0">未同步</span>
                <span v-if="scope.row.is_sync_product==1">已同步</span>
    
            </template>
            </el-table-column>
    

            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="140">
            <template slot-scope="scope">
              <el-button v-if="scope.row.is_sync_product==0" @click="editClick(scope.row.id)" type="text" size="small">编辑</el-button>
             
              <el-button v-if="scope.row.is_sync_product==0" @click="syncClick(scope.row.id,scope.row)" type="text" size="small">同步产品</el-button>
             
             
             
              </template>
          </el-table-column> 
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <Edit :open_edit="open_edit" :id="id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Sync :open_psin="open_psin" :id="psin_id"  v-if="open_psin"   @close="closeSync"></Sync>
  </div>
</template>

<script>
import PsinApi from '@/api/psin.js';
import Edit from './edit.vue';
import Sync from './sync.vue';
export default {
  components: {
    Edit,
    Sync,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_ratio:-1,
        code:"",
        is_sync_product:-1
      },
      app_id:"",

      open_edit:false,
      id:0,

      open_psin:false,
      psin_id:0,


    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    editClick(id){
      this.open_edit = true;
      this.id = id;
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },

    syncClick(id,row){
      // this.open_psin = true;
      this.psin_id = id;
      let self = this;
  
      let params = {
        num:row.count,
      };
      params.psin_id =  self.psin_id;

      self.loading = true;
      PsinApi.syncProduct(params, true)
        .then(data => {
                   self.$message({
            message: data.msg,
            type: 'success'
          });
          this.getTableList();
    
        })
        .catch(error => {
          self.loading = false;
        });
    },
    closeSync(e){
      this.open_psin=false;
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      console.log("------")
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;

      PsinApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.app_id = data.data.app_id;
        })
        .catch(error => {});
    },
    sync(code){
        //跳转同步页面
        if(this.app_id.length <= 0){
          this.$message({
              message: '系统错误，请稍后再试',
              type: 'success'
            });  
          return;
        }
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let url = baseUrl + '/index.php/job/ApiSync/run?app_id='+this.app_id+"&code="+code;
        window.open(url)
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },



  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/psin/index/index.vue